import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { useNeedsAttentionForAdapter } from '@bingads-webui-campaign-react/attention-beacon';

export const ImageListBeaconAdapter = (WrappedComponent) => {
  const HOC = ({
    imageListState,
    validationProps,
    attentionBeaconAdapterProps: attentionBeaconAdapterPropsFromProps,
    ...restProps
  }) => {
    const { errorMessages, isDirty } = imageListState;

    const needsAttentionLocal = useMemo(() => {
      const showValidationError = (validationProps.alwaysShowError || isDirty) && !_.isEmpty(errorMessages);
      return showValidationError;
    }, [validationProps.alwaysShowError, errorMessages, isDirty]);

    const { attentionBeaconAdapterProps } = useNeedsAttentionForAdapter({
      needsAttentionLocal,
      attentionBeaconAdapterProps: attentionBeaconAdapterPropsFromProps,
    });

    return (
      <WrappedComponent
        imageListState={imageListState}
        validationProps={validationProps}
        {...restProps}
        {...WrappedComponent.isAttentionBeaconAdapter ? { attentionBeaconAdapterProps } : {}}
      />
    );
  };

  HOC.propTypes = {
    imageListState: PropTypes.shape({
      errorMessages: PropTypes.arrayOf(PropTypes.string),
      isDirty: PropTypes.bool,
    }).isRequired,
    validationProps: PropTypes.shape({
      alwaysShowError: PropTypes.bool,
    }),
    attentionBeaconAdapterProps: PropTypes.shape({
      onAdapterNeedsAttentionChange: PropTypes.func.isRequired,
    }).isRequired,
  };

  HOC.defaultProps = {
    validationProps: {},
  };

  hoistNonReactStatics(HOC, WrappedComponent);
  HOC.displayName = `ValidationBeaconAdapter(${getDisplayName(WrappedComponent)})`;
  HOC.isAttentionBeaconAdapter = true;

  return HOC;
};
